import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import CommandStrings from '../Commands.resx';
import { HideWithSelection } from '../../selectionVisibility/SelectionVisibility';
import { UploadFolderAction } from '../../actions/upload/UploadFolderAction';

export const uploadFolderCommand: ICommand = {
  key: new Facet('uploadFolder').id,
  automationId: 'uploadFolderCommand',
  name: CommandStrings.UploadFolder,
  action: <HideWithSelection><UploadFolderAction /></HideWithSelection>
};
